import { io } from 'socket.io-client';
const { store, TOKEN, getValue } = require('../store');

let _client;

store[TOKEN].subscribe((token) => {
  if (_client) {
    _client.disconnect();
    _client = null;
  }
});

export function getSocket() {
  if (_client) {
    return _client;
  }

  // Connection to /api
  const socket = io({
    auth: (cb) => {
      const token = getValue(TOKEN);
      if (!token) {
        return cb({ error: 'Unauthorized' });
      }
      cb({ token });
    },
  });

  _client = socket;
  return socket;
}
